<div [class]="field.styleValue" [attr.lang]="metadataValue.language">
    <span>
        <a class="metadata-text" href="{{link.href}}" rel="noopener noreferrer" target="_blank">
            <i class="me-2 fa-xl" [ngClass]="iconStyle || defaultIcon"></i>
            {{ link.text }}
        </a>
    </span>
</div>
